function _addEventListeners() {
  console.log("Add event listeners");
  // Product items are wrapped in an href for easy clicking.
  // However, there are a few functional buttons inside the element that need to be clickable.
  // We therefore have to block all click events on the href with javascript, and only navigate if conditions match
  document.addEventListener(
    "click",
    function (e) {
      if (
        !e.target.matches("[data-prevent-click]") &&
        (e.target.matches("product-card a") || e.target.closest("product-card a"))
      ) {
        window.location.href = e.target.closest("product-card a").getAttribute("href");
        return true;
      }
      return false;
    },
    false
  );
}

_addEventListeners();

document.querySelectorAll("product-card").forEach(function (productCard) {
  productCard
    .querySelector(".product-card__quick-add-button")
    .addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".product-card[open]")?.removeAttribute("open");
      productCard.setAttribute("open", "");
    });
});

//if clicked anywhere on the page, close the open product card
document.addEventListener("click", function (e) {
  if (!e.target.closest("product-card") && document.querySelector("product-card[open]")) {
    document.querySelector("product-card[open]").removeAttribute("open");
  }
});
